import type { Profile } from '@shady-pines/db';
import { type Password } from '@shady-pines/types';
import { useCallback } from 'react';
import { handleSignIn } from './handle-sign-in';
import { useSupabase } from './use-supabase';

export const useSignIn = () => {
  const supabase = useSupabase();

  return useCallback(
    async (
      {
        emailOrUserName,
        password,
      }: {
        password: Password;
        emailOrUserName: string;
      },
      {
        onError,
        onSuccess,
        onPasswordResetRequired,
      }: {
        onError: (error: any) => void;
        onSuccess: () => void;
        onPasswordResetRequired: () => void;
      },
      appVersion?: Profile['app_version'],
    ) => {
      await handleSignIn(
        supabase,
        {
          emailOrUserName,
          password,
        },
        {
          onError,
          onSuccess,
          onPasswordResetRequired,
        },
        appVersion,
      );
    },
    [supabase],
  );
};
